import { render, staticRenderFns } from "./DialogEditUserTags.vue?vue&type=template&id=f843baa0"
import script from "./DialogEditUserTags.vue?vue&type=script&lang=js"
export * from "./DialogEditUserTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports